import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { SetTimeAutoDriftDialogData } from '@app/shared/components/dialogs/set-time-auto-drift-dialog/set-time-auto-drift-dialog.data';

@Component({
    selector : 'set-time-auto-drift',
    template: require('./set-time-auto-drift-dialog.component.html'),
    styles: [require('./set-time-auto-drift-dialog.component.scss')]
})
export class SetTimeAutoDriftDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: SetTimeAutoDriftDialogData) {
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/set-time-auto-drift-dialog/set-time-auto-drift-dialog.component.ts